import axios from '@/axios/config'

export default {
  namespaced: true,
  actions: {
    async fetchGuests(_store, params) {
      const { data } = await axios.get(`/api/guests`, {
        params,
      })
      return data
    },
    async updateGuest(_store, { id, ...payload }) {
      const { data } = await axios.put(`/api/guests/${id}`, payload)
      return data
    },
    async updateReservationGuest(_store, { res_id, ...payload }) {
      const { data } = await axios.put(
        `/api/reservations/${res_id}/info`,
        payload
      )
      return data
    },
    async fetchGuest(_store, id) {
      const { data } = await axios.get(`/api/guests/${id}`)
      return data
    },
    async updateGuestNotes(_store, { id, notes }) {
      const { data } = await axios.post(`/api/guests/${id}/notes`, {
        notes,
      })
      return data
    },
  },
}
